import { Component, OnInit } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { ChannelsService } from '../../infrastructure/services/channels.service';
import { BuscadorPipe } from '../../helpers/pipes/buscador.pipe';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';

@Component({
  templateUrl: './listado.channels.component.html',
  providers: [ChannelsService, BuscadorPipe]
})
export class ListadoChannelsComponent implements OnInit {
  codSubscription : string;
  channels: Observable<ItemGeneralListado[]>;
  ocultarNuevo = false; // define si debo o no mostrar el boton Nuevo
  codorganization: string;

  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private channelsService: ChannelsService) { }

  ngOnInit() {
    const { ocultarNuevo } = this.aRoute.snapshot.data;
    this.ocultarNuevo = ocultarNuevo;

    this.aRoute.params.subscribe((params: Params) => {
      this.codorganization = params['codorganizacion'];
      this.codSubscription = params['codsistema'];
      this.channels = this.channelsService.getForList(this.codorganization,this.codSubscription);
    });
  }

  navegarNuevoChannel() {
    this.router.navigate(['nuevo'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/listado.channels.component.ts